/**
 * Runtime site-copy overlay (#662).
 *
 * Fetches the published copy overrides from our own backend
 * (`GET /api/config/site-copy`, served from PlatformSetting) and merges them
 * over the baked-in `en` translation bundle.
 *
 * The public site never depends on AIMEAT at render time: AIMEAT is only the
 * drafting channel (agent → SuperAdmin review → publish). If this fetch fails
 * or returns no overrides, the baked-in bundle text stays in place.
 */
import { loadTranslations } from './i18n';
import { useLocaleStore } from '../store/useLocaleStore';

interface SiteCopyResponse {
  entries?: Record<string, string>;
}

export async function applySiteCopyOverlay(): Promise<void> {
  try {
    const res = await fetch('/api/config/site-copy');
    if (!res.ok) return;
    const data = (await res.json()) as SiteCopyResponse;
    const entries = data?.entries;
    if (!entries || typeof entries !== 'object' || Object.keys(entries).length === 0) return;
    // Overrides are EN-based for now. fi/sv lack public.* keys and fall back
    // to the 'en' bundle, so overlaying 'en' covers every locale.
    loadTranslations('en', entries);
    useLocaleStore.getState().bumpBundlesVersion();
  } catch {
    // Silent by design: baked-in copy renders whenever the overlay is unavailable.
  }
}
